import React from "react";
import Footer from "../components/Footer";
import Hero from "../components/Heros/HeroStore";

// TossPayments 전역 정의
declare global {
  interface Window {
    TossPayments: any;
  }
}

const clientKey = "test_ck_D5GePWvyJnrK0W0k6q8gLzN97Eoq";

const StoreDetail = () => {
  // ✅ 여기서 정의합니다
  const handleTossPayment = () => {
    if (!window.TossPayments) {
      alert("TossPayments SDK가 로드되지 않았습니다.");
      return;
    }

    const tossPayments = window.TossPayments(clientKey);
    const orderId = `${crypto.randomUUID().replace(/-/g, "").slice(0, 8)}-${Date.now()}`;

    tossPayments
      .requestPayment("카드", {
        amount: 20000,
        orderId,
        orderName: "Salesforce Cap - Tech Zip Cap",
        customerName: "비회원 주문", // 비회원 이름 또는 입력값
        successUrl: "https://90dhnop7pf.execute-api.ap-northeast-2.amazonaws.com/v1/toss/confirm",
        failUrl: "https://docs.tosspayments.com/guides/payment/test-fail",
      })
      .catch((error: { code: string }) => {
        // 사용자가 직접 취소한 경우는 알림 없이 넘어간다
        if (error.code !== "USER_CANCEL") {
          alert("결제 실패: " + error.code);
        }
      });
  };

  return (
    <>
        <Hero />
        <section className="py-6 dark:bg-gray-800 dark:text-gray-100 sm:py-12">
            <div className="sd_container mx-auto space-y-8 p-6">
                <div className="container mx-auto flex items-center flex-wrap justify-center pt-4 pb-12">

                    <div className="pt-6">
                        <nav aria-label="Breadcrumb">
                            <ol role="list"
                                className="mx-auto flex max-w-2xl items-center space-x-2 px-4 sm:px-6 lg:max-w-7xl lg:px-8">
                                <li>
                                    <div className="flex items-center">
                                        <a href="#" className="mr-2 text-sm font-medium text-gray-900">모자</a>
                                        <svg width="16" height="20" viewBox="0 0 16 20" fill="currentColor"
                                             xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
                                             className="h-5 w-4 text-gray-300">
                                            <path d="M5.697 4.34L8.98 16.532h1.327L7.025 4.341H5.697z"/>
                                        </svg>
                                    </div>
                                </li>

                                <li>
                                    <div className="flex items-center">
                                        <a href="#" className="mr-2 text-sm font-medium text-gray-900">Cap</a>
                                        <svg width="16" height="20" viewBox="0 0 16 20" fill="currentColor"
                                             xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
                                             className="h-5 w-4 text-gray-300">
                                            <path d="M5.697 4.34L8.98 16.532h1.327L7.025 4.341H5.697z"/>
                                        </svg>
                                    </div>
                                </li>

                                <li className="text-sm">
                                    <a href="#" aria-current="page"
                                       className="font-medium text-gray-500 hover:text-gray-600">Salesforce Cap</a>
                                </li>
                            </ol>
                        </nav>

                        <div
                            className="mx-auto mt-6 max-w-2xl sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-3 lg:gap-x-8 lg:px-8">
                            <div
                                className="aspect-w-3 aspect-h-4 hidden overflow-hidden border border-gray-200 rounded-lg lg:block">
                                <img className="object-contain object-center"
                                 src="/img/product/img-01.png"
                                     alt="Two each of gray, white, and black shirts laying flat."/>
                            </div>
                            <div className="hidden lg:grid lg:grid-cols-1 lg:gap-y-8">
                                <div
                                    className="aspect-w-3 aspect-h-2 overflow-hidden  border border-gray-200 rounded-lg">
                                    <img className="object-contain object-center"
                                    src="/img/product/img-01.png"
                                         alt="Model wearing plain black basic tee."/>
                                </div>
                                <div
                                    className="aspect-w-3 aspect-h-2 overflow-hidden  border border-gray-200 rounded-lg">
                                    <img className="object-contain object-center"
                                    src="/img/product/img-03.png"
                                         alt="Model wearing plain gray basic tee."/>
                                </div>
                            </div>
                            <div
                                className="aspect-w-4 aspect-h-5 sm:overflow-hidden border border-gray-200 sm:rounded-lg lg:aspect-w-3 lg:aspect-h-4">
                                <img className="object-contain object-center"
                                    src="/img/product/img-02.png"
                                     alt="Model wearing plain white basic tee."/>
                            </div>
                        </div>

                        <div
                            className="mx-auto max-w-2xl px-4 pt-10 pb-16 sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-3 lg:grid-rows-[auto,auto,1fr] lg:gap-x-8 lg:px-8 lg:pt-16 lg:pb-24">
                            <div className="lg:col-span-2 lg:border-r lg:border-gray-200 lg:pr-8">
                                <h1 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">Salesforce Cap</h1>
                            </div>

                            <div className="mt-4 lg:row-span-3 lg:mt-0">
                                <h2 className="sr-only">Product information</h2>
                                <p className="text-3xl tracking-tight text-gray-900">20,000원</p>

                                <div className="mt-6">
                                    <h3 className="sr-only">Reviews</h3>
                                    <div className="flex items-center">
                                        <div className="flex items-center">
                                            <svg className="text-gray-900 h-5 w-5 flex-shrink-0"
                                                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                 fill="currentColor" aria-hidden="true">
                                                <path fill="evenodd"
                                                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z"
                                                      clip="evenodd"/>
                                            </svg>

                                            <svg className="text-gray-900 h-5 w-5 flex-shrink-0"
                                                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                 fill="currentColor" aria-hidden="true">
                                                <path fill="evenodd"
                                                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z"
                                                      clip="evenodd"/>
                                            </svg>

                                            <svg className="text-gray-900 h-5 w-5 flex-shrink-0"
                                                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                 fill="currentColor" aria-hidden="true">
                                                <path fill="evenodd"
                                                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z"
                                                      clip="evenodd"/>
                                            </svg>

                                            <svg className="text-gray-900 h-5 w-5 flex-shrink-0"
                                                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                 fill="currentColor" aria-hidden="true">
                                                <path fill="evenodd"
                                                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z"
                                                      clip="evenodd"/>
                                            </svg>

                                            <svg className="text-gray-200 h-5 w-5 flex-shrink-0"
                                                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                 fill="currentColor" aria-hidden="true">
                                                <path fill="evenodd"
                                                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z"
                                                      clip="evenodd"/>
                                            </svg>
                                        </div>
                                        <p className="sr-only">4 out of 5 stars</p>
                                        <a href="#"
                                           className="ml-3 text-sm font-medium text-indigo-600 hover:text-indigo-500">117
                                            reviews</a>
                                    </div>
                                </div>

                                <form className="mt-10">
                                    <div>
                                        <h3 className="text-sm font-medium text-gray-900">색상</h3>

                                        <fieldset className="mt-4">
                                            <legend className="sr-only">Choose a color</legend>
                                            <div className="flex items-center space-x-3">
                                                <label
                                                    className="-m-0.5 relative p-0.5 rounded-full flex items-center justify-center cursor-pointer focus:outline-none ring-gray-400">
                                                    <input type="radio" name="color-choice" value="White" className="sr-only" aria-labelledby="color-choice-0-label"/>
                                                    <span id="color-choice-0-label" className="sr-only"> White </span>
                                                    <span aria-hidden="true" className="bg-color-sky h-8 w-8 border border-black border-opacity-10 rounded-full"></span>
                                                </label>

                                                <label
                                                    className="-m-0.5 relative p-0.5 rounded-full flex items-center justify-center cursor-pointer focus:outline-none ring-gray-400">
                                                    <input type="radio" name="color-choice" value="Gray" className="sr-only" aria-labelledby="color-choice-1-label" />
                                                    <span id="color-choice-1-label" className="sr-only"> Gray </span>
                                                    <span aria-hidden="true" className="h-8 w-8 bg-gray-200 border border-black border-opacity-10 rounded-full"></span>
                                                </label>

                                                <label
                                                    className="-m-0.5 relative p-0.5 rounded-full flex items-center justify-center cursor-pointer focus:outline-none ring-gray-900">
                                                    <input type="radio" name="color-choice" value="Black" className="sr-only" aria-labelledby="color-choice-2-label" />
                                                    <span id="color-choice-2-label" className="sr-only"> Black </span>
                                                    <span aria-hidden="true" className="h-8 w-8 bg-gray-900 border border-black border-opacity-10 rounded-full"></span>
                                                </label>
                                            </div>
                                        </fieldset>
                                    </div>

                                    <button type="button"
                                            onClick={handleTossPayment}
                                            className="mt-10 flex w-full items-center justify-center rounded-md border border-transparent bg-indigo-600 py-3 px-8 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">비회원 주문하기
                                    </button>
                                </form>
                            </div>

                            <div
                                className="py-10 lg:col-span-2 lg:col-start-1 lg:border-r lg:border-gray-200 lg:pt-6 lg:pb-16 lg:pr-8
                                border-b-[1px] border-indigo-500">
                                <div>
                                    <h3 className="sr-only">Description</h3>

                                    <div className="space-y-6">
                                        <p className="text-base text-gray-900">
                                            This cotton cap is comfortable and easy to wear.
                                            It contains a structured 6 panel design with slight
                                            pre-curved peak, comfortable padded sweatband and
                                            velcro closure at base for easy adjustable sizing.</p>
                                    </div>
                                </div>

                                <div className="mt-10">
                                    <h3 className="text-sm font-medium text-gray-900">Product Details</h3>

                                    <div className="mt-4">
                                        <ul role="list" className="list-disc space-y-2 pl-4 text-sm">
                                            <li className="text-gray-400"><span className="text-gray-600">Embroidered Salesforce logo on front</span>
                                            </li>

                                            <li className="text-gray-400"><span className="text-gray-600">Colour - Powder Blue, Black and Cyan, Navy and Natural</span>
                                            </li>

                                            <li className="text-gray-400"><span className="text-gray-600">100% heavy brushed cotton</span>
                                            </li>
                                            <li className="text-gray-400"><span className="text-gray-600">Breathable Polyester</span>
                                            </li>
                                            <li className="text-gray-400"><span className="text-gray-600">55% Hemp 45% Cotton</span>
                                            </li>
                                            <li className="text-gray-400"><span className="text-gray-600">Polyester mesh</span>
                                            </li>
                                            <li className="text-gray-400"><span className="text-gray-600">contains a structured 6 panel design</span>
                                            </li>
                                            <li className="text-gray-400"><span className="text-gray-600">slight pre-curved peak</span>
                                            </li>
                                            <li className="text-gray-400"><span className="text-gray-600">comfortable padded sweatband</span>
                                            </li>
                                            <li className="text-gray-400"><span className="text-gray-600">velcro closure at base for easy adjustable sizing</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>

                            <div
                                className="py-10 lg:col-span-2 lg:col-start-1 lg:border-r lg:border-gray-200 lg:pt-6 lg:pb-16 lg:pr-8
                                border-b-[1px] border-indigo-500">
                                <div>
                                    <h3 className="sr-only">Description</h3>

                                    <div className="space-y-6">
                                        <h3 className="text-base font-semibold text-gray-900">교환 및 반품 안내</h3>
                                        <ul className="flex flex-col items-start gap-2">
                                            <li><span className="text-sm font-medium text-gray-900 block float-left">배송 비용</span>
                                                <p className="space-y-2 pl-4 text-sm text-gray-600 float-left">단순 변심은 왕복 택배비 5,000원 </p>
                                            </li>
                                            <li><span className="text-sm font-medium text-gray-900 block float-left">반품 주소</span>
                                                <p className="space-y-2 pl-4 text-sm text-gray-600 float-left">서울 영등포구 문래북로 8 에이스NS타워 1111호</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="mt-10">
                                    <h3 className="text-sm font-medium text-gray-900">유의 사항</h3>

                                    <div className="mt-4">
                                        <ul role="list" className="list-disc space-y-2 pl-4 text-sm">
                                            <li className="text-gray-400">
                                                <span className="text-gray-600">단순 변심의 경우 수령일로부터 7일 이내까지 교환•반품이 가능합니다. (교환/ 반품비 고객 부담)</span>
                                            </li>

                                            <li className="text-gray-400">
                                                <span className="text-gray-600">상품 하자, 오배송의 경우 수령일로부터 7일 이내 교환•반품이 가능합니다. (교환/ 반품비 무료)</span>
                                            </li>

                                            <li className="text-gray-400">
                                                <span className="text-gray-600">제품 특성상 단순 변심, 부주의에 의한 제품 손상 및 파손, 사용 및 개봉한 경우 교환/ 반품이 불가합니다.</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>

                            <div
                                className="py-10 lg:col-span-2 lg:col-start-1 lg:border-r lg:border-gray-200 lg:pt-6 lg:pb-16 lg:pr-8">
                                <div>
                                    <h3 className="sr-only">Description</h3>

                                    <div className="space-y-6">
                                        <h3 className="text-base font-semibold text-gray-900">배송안내</h3>
                                        <ul className="flex flex-col items-start gap-2">
                                            <li><span className="text-sm font-medium text-gray-900 block float-left">배송 지역</span>
                                                <p className="space-y-2 pl-4 text-sm text-gray-600 float-left">대한민국 전 지역</p>
                                            </li>
                                            <li><span className="text-sm font-medium text-gray-900 block float-left">배송 비용</span>
                                                <p className="space-y-2 pl-4 text-sm text-gray-600 float-left">2,500원/ 구매 금액 50,000원 이상 시 무료 배송/ 도서산간 지역 별도 추가 금액 발생</p>
                                            </li>
                                            <li><span className="text-sm font-medium text-gray-900 block float-left">배송 기간</span>
                                                <p className="space-y-2 pl-4 text-sm text-gray-600 float-left">주말•공휴일 제외 2-3일</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="mt-10">
                                    <h3 className="text-sm font-medium text-gray-900">유의 사항</h3>

                                    <div className="mt-4">
                                        <ul role="list" className="list-disc space-y-2 pl-4 text-sm">
                                            <li className="text-gray-400">
                                                <span className="text-gray-600">주문 폭주 및 공급 사정으로 인하여 지연 및 품절이 발생될 수 있습니다.</span>
                                            </li>

                                            <li className="text-gray-400">
                                                <span className="text-gray-600">기본 배송기간 이상 소요되는 상품이거나, 품절 상품은 개별 연락을 드립니다.</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
                <div className="space-y-2 text-center">
                    <h2 className="text-3xl font-bold md:text-4xl">
                    {/*  상품 리스트 화면 작업 */}
                    </h2>
                </div>
            </div>
        </section>
        <Footer />
    </>
    );
};
export default StoreDetail;